/**
 * Screen size widths
 */
export enum ScreenSize {
  _320 = "320px",
  _350 = "350px",
  _425 = "425px",
  _720 = "720px",
  _768 = "768px",
  _920 = "920px",
  _1024 = "1024px",
  _1280 = "1280px",
  _1440 = "1440px",
  _1520 = "1520px",
  _1920 = "1920px",
}